<template>
  <div v-if="onnet" style="color: white;">
    <b-button-toolbar aria-label="Connect and Disconnect toolbar">
      <b-button-group size="sm" class="mr-2 mt-1">
        <b-button variant="success" :disabled="connected || !onnet || isMacauth" :title="isMacauth ? 'Disabled: this device is already registered.':''" @click="toggleOnConnection">Connect</b-button>
        <b-button variant="danger" :disabled="!connected || !onnet || isMacauth" :title="isMacauth ? 'Disabled: this device is already registered.':''" @click="toggleOffConnection">Disconnect</b-button>
      </b-button-group>
    </b-button-toolbar>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { connectToInternet, disconnectFromInternet } from 'src/cpd';

export default {
  name: 'ConnectSwitch',
  computed: {
    ...mapState("captive", {      
      onnet: state => state.onnet
    }),
    ...mapGetters("captive", {
      connected: "isConnected",
      status: "status",
      isMacauth: "isMacauth"
    })
  },
  methods: {
    async toggleOnConnection() {
      this.$log.onError('toggle conn on');
      // if (!this.connected) {
        await connectToInternet();
      // }
    },
    async toggleOffConnection() {
      this.$log.onError('toggle conn off');
      // if (this.connected) {
        await disconnectFromInternet();
      // }
    }
  },
};
</script>

<style scoped>

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #101010;
}

input:focus + .slider {
  box-shadow: 0 0 1px #101010;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>